export const config = {
  // @TODO: Pull tournament title and description from the API depending on the tenant
  tournamentTitle: 'Title',
  tournamentDescription: 'Description',
  halftimeDuration: 10 * 60,
} as const;
